import { useContext } from "react";
import initialAppData from "../components/Context/InitialAppDataContext.d";
import { InitialAppDataContext } from "../components/Context/InitialAppDataContext";
export default function useInitialAppData(): initialAppData {
	return useContext(InitialAppDataContext);
}
